/**
 * Helper functions to format redux-json-api responses
 */

/**
 * Creates a resource payload for redux-json-api
 * @param {string} type - Resource type
 * @param {Object} attributes - Resource attributes
 * @returns {Object} JSONAPI resource object
 */
export function createResourcePayload(type, attributes) {
  return {
    type,
    attributes
  }
}

/**
 * Extracts and formats coupon validation response
 * @param {Object} response - redux-json-api response
 * @returns {Object} Formatted coupon validation result
 */
export function formatCouponValidationResponse(response) {
  const attrs = response.data.attributes
  
  return {
    valid: attrs.valid,
    couponCode: attrs['coupon-code'],
    originalAmount: attrs['original-amount'],
    discountAmount: attrs['discount-amount'],
    finalAmount: attrs['final-amount'],
    errorMessage: attrs['error-message']
  }
}

/**
 * Extracts and formats payment intent response
 * @param {Object} response - redux-json-api response
 * @returns {Object} Formatted payment intent data
 */
export function formatPaymentIntentResponse(response) {
  const attrs = response.data.attributes

  return {
    clientSecret: attrs['client-secret'],
    paymentIntentId: attrs['payment-intent-id'],
    amount: attrs.amount,
    originalAmount: attrs['original-amount'],
    discountAmount: attrs['discount-amount'],
    couponCode: attrs['coupon-code']
  }
}

/**
 * Extracts and formats payment record response
 * @param {Object} payment - redux-json-api payment data object
 * @returns {Object} Formatted payment record
 */
export function formatPaymentRecord(payment) {
  const attrs = payment.attributes

  return {
    id: payment.id,
    everplanId: attrs['everplan-id'],
    amount: attrs.amount,
    status: attrs.status,
    stripePaymentIntentId: attrs['stripe-payment-intent-id'],
    cardBrand: attrs['card-brand'],
    cardLast4: attrs['card-last4'],
    errorMessage: attrs['error-message'],
    couponCode: attrs['coupon-code'],
    createdAt: attrs['created-at'],
    updatedAt: attrs['updated-at']
  }
}

